import React from 'react';
import './component002.less';

interface IComponent002Props {
  title1?: string;
  title2?: string;
  canDoItems: string[];
  cannotDoItems: string[];
  className?: string;
}

const Component002: React.FunctionComponent<IComponent002Props> = ({
  title1,
  title2,
  canDoItems,
  cannotDoItems,
  className,
}) => (
  <>
    <div className={`component002 ${className}`}>
      <div className="cando-section">
        <div className="can-do">
          <div className="cando-title" style={{ backgroundColor: '#0CA39A' }}>
            {title1}
          </div>
          <div className="cando-body">
            <div className="cando-content">
              <ul>
                {canDoItems.map((x: string) => (
                  <li>{x}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="can-not-do">
          <div className="cando-title" style={{ backgroundColor: '#0CA39A' }}>
            {title2}
          </div>
          <div className="cando-body">
            <div className="cando-content">
              <ul>
                {cannotDoItems.map((itm: string) => (
                  <li>{itm}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
export default Component002;
